
import {IUserLogEntryBuilder} from './i.user.log.entry.builder';
import {IUserLogEntryOptions} from './i.user.log.entry.options';
import {UserLogEntryHelper} from "@/models/userlog/user.log.entry.helper";

/**
 *
 * @class CanPassBuilder
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      April 2021
 *
 */
export class CanPassBuilder implements IUserLogEntryBuilder {

  /** convert raw MongoDB user log entry into data that can construct a tree node */
  build(data: any, args: IUserLogEntryOptions): any {

    const u:        string = data._id.match(/^can-pass-(.*)/i)[1];

    let targetTrain:   any = null;
    let start:         any = null;
    let end:           any = null;
    let proposed:      any = null;

    const opposing: string = data.op;

    if (data.tt) {

      targetTrain = {
        id:              data._id,
        name:            `${data.tt.n}-${data.tt.d} [ ${data.tt.src.n} - ${data.tt.dst.n} ] ${data.tt.tp}-${data.tt.u}`,
        uuid:            data.tt.u,
        kind:            data.tt.tp,
        direction:       data.tt.d,
        source: {
          name:          data.tt.src.n,
          mileage:       data.tt.src.m
        },
        destination: {
          name:          data.tt.dst.n,
          mileage:       data.tt.dst.m
        },
        trainClass:      data.tt.tc,
        tonnage:         data.tt.ton,
        length:          data.tt.l,
        priority:        data.tt.pri,
        overtake:        data.tt.o,
        u:               data.tt._id
      };
    }

    if (data.st) {

      let before: any    = null;
      let after: any     = null;

      if (data.st.a != null) {

        after = {
          name:    data.st.a.d,
          mileage: data.st.a.m
        };
      }

      if (data.st.b != null) {

        before = {
          name:    data.st.b.d,
          mileage: data.st.b.m
        };
      }

      start = {
        id:      data.st.i,
        track:   data.st.t,
        mileage: data.st.m,
        before,
        after
      };
    }

    if (data.en) {

      let before: any    = null;
      let after: any     = null;

      if (data.en.a != null) {

        after = {
          name:    data.en.a.d,
          mileage: data.en.a.m
        };
      }

      if (data.en.b != null) {

        before = {
          name:    data.en.b.d,
          mileage: data.en.b.m
        };
      }

      end = {
        id:      data.en.i,
        track:   data.en.t,
        mileage: data.en.m,
        before,
        after
      };
    }

    if (data.pr) {

      let before: any    = null;
      let after: any     = null;

      if (data.pr.a != null) {

        after = {
          name:    data.pr.a.d,
          mileage: data.pr.a.m
        };
      }

      if (data.pr.b != null) {

        before = {
          name:    data.pr.b.d,
          mileage: data.pr.b.m
        };
      }

      proposed = {
        id:      data.pr.i,
        track:   data.pr.t,
        mileage: data.pr.m,
        before,
        after
      };
    }

    const pr: string     = UserLogEntryHelper.trackString(data.pr);
    let target: string   = '';

    if (targetTrain != null) {

      target = ` [ ${targetTrain.name}-${targetTrain.direction} ${targetTrain.uuid} ]`;
    }

    return {
      id:              data._id,
      seq:             parseInt(data.seq),
      name:            `Can Pass: ${pr} ${target}`,
      hasChildren:     args.hasChildren,
      isExpanded:      args.isExpanded,
      type:            'can-pass',
      children:        args.children,
      parent:          args.parent,
      kids:            data.ch,
      tags:            data.tg,
      label:           data.lb,
      pkey:            data.pa,
      opposing,
      targetTrain,
      start,
      end,
      proposed,
      u:               data._id
    };

  }
}
